__turbopack_context__.v({
  "chip-link": "ChipLink-module-scss-module__hT-NOa__chip-link",
});
